import { Component, ChangeDetectionStrategy, OnInit, EventEmitter, Output, inject } from '@angular/core';
import { takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ViewMode } from '@src/models';
import { AlertService } from '@src/core/services';
import { BaseComponent } from '@src/app/modules/base';

import { ContactsCustomListItem } from '../../types';
import { CustomListService } from '../../services';

@Component({
  selector: 'directory-list',
  templateUrl: './directory-list.component.html',
  styleUrls: ['./directory-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirectoryListComponent extends BaseComponent implements OnInit {
  private readonly customListService = inject(CustomListService);
  private readonly alertService = inject(AlertService);
  private readonly translateService = inject(TranslateService);

  @Output() selectDirectory = new EventEmitter<ContactsCustomListItem>();

  customListDirectories$ = this.customListService.customListDirectories$;
  mode: ViewMode = 'view';

  ngOnInit(): void {
    this.customListService.getCustomListDirectories();
  }

  onSave(values: ContactsCustomListItem[]) {
    this.customListService
      .saveDirectories(values)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe({
        complete: () => {
          this.mode = 'view';
          this.alertService.success(this.translateService.instant('common.alerts.successes.saveData'));

          this.customListService.getCustomListDirectories();
        },
      });
  }

  removeItem(value: string) {
    this.customListService
      .deleteCustomListDirectoryObservable(value)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(() => {
        this.customListService.getCustomListDirectories();
      });
  }
}
